// Localização: frontend/src/context/SidebarContext.js
// Contexto para compartilhar o estado de hover do Sidebar com outros componentes

import React, { createContext, useContext, useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
    const [isHovered, setIsHovered] = useState(false);
    const timeoutRef = useRef(null);
    const location = useLocation();

    // 🎯 Garantir que o sidebar sempre comece colapsado ao acessar o sistema
    // Reseta o estado quando o componente monta ou quando a rota muda
    useEffect(() => {
        // Limpar qualquer timeout pendente
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        // Garantir que o sidebar está colapsado
        setIsHovered(false);
    }, [location.pathname]); // Reseta quando a rota muda

    // Função para ativar hover com delay de saída
    const handleMouseEnter = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setIsHovered(true);
    };

    // Função para desativar hover com delay
    const handleMouseLeave = () => {
        // Delay de 150ms antes de colapsar para evitar "piscar"
        timeoutRef.current = setTimeout(() => {
            setIsHovered(false);
        }, 150);
    };

    // Cleanup do timeout
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return (
        <SidebarContext.Provider value={{ isHovered, setIsHovered, handleMouseEnter, handleMouseLeave }}>
            {children}
        </SidebarContext.Provider>
    );
};

export const useSidebar = () => {
    const context = useContext(SidebarContext);
    if (!context) {
        throw new Error('useSidebar deve ser usado dentro de SidebarProvider');
    }
    return context;
};

